export default [{
        path: "/facturasweb",
        name: "facturasweb",
        component: () =>
            import(
                /* webpackChunkName: "facturasweb.public"*/
                "./vue-components/public/facturasweb-buscar.vue"
            ),
    },
    {
        path: "/facturasweb*",
        redirect: {
            name: "facturasweb",
        },
    },
];
